import React from 'react'
import { getUsdtPayoutOrders, formatNumbers } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';

const OrderHistory = ({ userId, ordersHistory,tokenSymbol }) => {
    const { t } = useTranslation();
    return (
        <>
            {ordersHistory && ordersHistory?.length > 0 ? (
                ordersHistory?.filter(order => order.user === userId)?.map((order) => (
                    <>
                        <div className="openorderlist">
                            <div className="single-list">
                                <p>{t('Option')}</p>
                                <h6>
                                    {order.optionDetail.optionName}
                                </h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Opened at')}</p>
                                <h6>{new Date(order.createdAt).toLocaleString()}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Type')}</p>
                                <h6 className={order.orderType === 'sell' ? 'sell-color' : 'buy-color'}>{order.orderType}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Price per share')}</p>
                                <h6>{Number(order.pricePerShare).toFixed(2)} {tokenSymbol}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t('Shares')}</p>
                                <h6>{formatNumbers(+(order.quantity))}</h6>
                            </div>
                            <div className="single-list">
                                <p>{t(`${tokenSymbol} you get`)}</p>
                                <h6>{formatNumbers(getUsdtPayoutOrders(order.pricePerShare, order.quantity))} {tokenSymbol}</h6>
                            </div>
                            {/* <div className="single-list">
                                <p>Filled Size</p>
                                <h6>0/{order.quantity} (0.00%)</h6>
                            </div> */}
                        </div>
                    </>
                ))
            ) : (
                <p className="text-white">{t('No order history found')}</p>
            )}
        </>
    );
};

export default OrderHistory